import React, { useState } from 'react';
import { Eye, EyeClosed } from 'iconoir-react';
import { C, St, FONT_BODY, focus, blur } from '../theme';
import { supabase } from '../supabase';

export function AuthPage() {
  const [email,setEmail]=useState("");
  const [password,setPassword]=useState("");
  const [mode,setMode]=useState("login");
  const [err,setErr]=useState("");
  const [info,setInfo]=useState("");
  const [busy,setBusy]=useState(false);
  const [showPwd,setShowPwd]=useState(false);
  const submit=async()=>{
    setErr("");setInfo("");
    if(!email.includes("@")||!email.includes(".")){ setErr("Inserisci un indirizzo email valido."); return; }
    if(password.length<6){ setErr("La password deve essere di almeno 6 caratteri."); return; }
    setBusy(true);
    try{
      if(mode==="login"){
        const{error}=await supabase.auth.signInWithPassword({email,password});
        if(error){ setErr("Email o password non corretti."); return; }
      } else {
        const{error}=await supabase.auth.signUp({email,password});
        if(error) setErr(error.message);
        else { setInfo("Account creato. Accedi per iniziare."); setMode("login"); setPassword(""); }
      }
    } finally { setBusy(false); }
  };

  const resetPassword=async()=>{
    if(!email){ setErr("Inserisci la tua email per reimpostare la password."); return; }
    setErr("");setInfo("");setBusy(true);
    const{error}=await supabase.auth.resetPasswordForEmail(email);
    setBusy(false);
    if(error) setErr(error.message);
    else setInfo("Email inviata. Controlla la tua casella di posta.");
  };

  return (
    <div style={{fontFamily:FONT_BODY,background:C.bg,minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",WebkitFontSmoothing:"antialiased"}}>
      <div style={{width:"100%",maxWidth:340,padding:"0 24px"}}>

        {/* Logo + heading */}
        <div style={{textAlign:"center",marginBottom:32}}>
          <div style={{margin:"0 auto 16px",width:64,height:64,filter:"drop-shadow(0 4px 14px rgba(52,199,89,0.35))"}}>
            <svg width="64" height="64" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="1" y="1" width="510" height="510" rx="119" fill="url(#ap0)"/>
              <rect x="1" y="1" width="510" height="510" rx="119" stroke="#C6C6C6" strokeWidth="2"/>
              <path d="M89.1712 355.573C85.0571 351.184 83 345.973 83 339.939C83 333.905 85.0571 328.831 89.1712 324.717L178.037 235.851C186.539 227.348 196.825 223.097 208.893 223.097C220.961 223.097 231.247 227.348 239.749 235.851L276.365 272.467L354.945 193.887H340.546C334.512 193.887 329.369 191.761 325.118 187.51C320.866 183.258 318.741 178.116 318.741 172.082C318.741 166.048 320.866 160.905 325.118 156.654C329.369 152.402 334.512 150.277 340.546 150.277H407.195C413.229 150.277 418.372 152.402 422.623 156.654C426.874 160.905 429 166.048 429 172.082V239.554C429 245.588 426.874 250.73 422.623 254.982C418.372 259.233 413.229 261.359 407.195 261.359C401.161 261.359 396.018 259.233 391.767 254.982C387.516 250.73 385.39 245.588 385.39 239.554V224.331L307.221 303.323C298.719 312.1 288.502 316.488 276.571 316.488C264.64 316.488 254.286 312.1 245.509 303.323L208.893 266.707L120.027 355.573C115.639 359.961 110.496 362.155 104.599 362.155C98.7023 362.155 93.5597 359.961 89.1712 355.573Z" fill="url(#ap1)"/>
              <defs>
                <linearGradient id="ap0" x1="256" y1="0" x2="256" y2="512" gradientUnits="userSpaceOnUse"><stop stopColor="white"/><stop offset="1" stopColor="#EDEDED"/></linearGradient>
                <linearGradient id="ap1" x1="423.107" y1="166.893" x2="77.5181" y2="347.916" gradientUnits="userSpaceOnUse"><stop stopColor="#34C759"/><stop offset="1" stopColor="#34C759" stopOpacity="0.6"/></linearGradient>
              </defs>
            </svg>
          </div>
          <h1 style={{fontSize:26,fontWeight:700,color:C.text,letterSpacing:-0.5,margin:"0 0 6px"}}>
            {mode==="login"?"Bentornato":"Crea account"}
          </h1>
          <p style={{fontSize:14,color:C.subtle,margin:0,lineHeight:1.5}}>
            {mode==="login"?"Accedi per continuare il tuo percorso.":"Inizia a tracciare i tuoi progressi."}
          </p>
        </div>

        {/* Email field */}
        <div style={{marginBottom:12}}>
          <label style={{...St.label,display:"block",marginBottom:6}}>Email</label>
          <div style={{position:"relative"}}>
            <span style={{position:"absolute",left:12,top:"50%",transform:"translateY(-50%)",color:C.subtle,pointerEvents:"none",display:"flex",alignItems:"center"}}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
            </span>
            <input style={{...St.input,paddingLeft:36}} type="email" value={email} onChange={e=>setEmail(e.target.value)} onFocus={focus} onBlur={blur} placeholder="tuaemail@esempio.com" onKeyDown={e=>e.key==="Enter"&&submit()}/>
          </div>
        </div>

        {/* Password field */}
        <div style={{marginBottom:16}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
            <label style={St.label}>Password</label>
            {mode==="login"&&<button onClick={resetPassword} disabled={busy} style={{background:"none",border:"none",color:C.blue,fontSize:13,cursor:"pointer",fontFamily:FONT_BODY,padding:0}}>Password dimenticata?</button>}
          </div>
          <div style={{position:"relative"}}>
            <span style={{position:"absolute",left:12,top:"50%",transform:"translateY(-50%)",color:C.subtle,pointerEvents:"none",display:"flex",alignItems:"center"}}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
            </span>
            <input style={{...St.input,paddingLeft:36,paddingRight:44}} type={showPwd?"text":"password"} value={password} onChange={e=>setPassword(e.target.value)} onFocus={focus} onBlur={blur} placeholder="La tua password" onKeyDown={e=>e.key==="Enter"&&submit()}/>
            <button onClick={()=>setShowPwd(p=>!p)} aria-label={showPwd?"Nascondi password":"Mostra password"} style={{position:"absolute",right:0,top:0,height:"100%",padding:"0 12px",background:"none",border:"none",color:C.subtle,cursor:"pointer",display:"flex",alignItems:"center"}}>
              {showPwd
                ?<EyeClosed width={15} height={15}/>
                :<Eye width={15} height={15}/>
              }
            </button>
          </div>
        </div>


        {/* Error / info banners */}
        {err&&<div style={{color:C.red,fontSize:13,marginBottom:12,lineHeight:1.5,padding:"10px 14px",background:C.redL,borderRadius:10}}>{err}</div>}
        {info&&<div style={{color:C.green,fontSize:13,marginBottom:12,lineHeight:1.5,padding:"10px 14px",background:C.greenL,borderRadius:10}}>{info}</div>}

        {/* Submit */}
        <button onClick={submit} disabled={busy} style={{...St.btn(C.blue),width:"100%",padding:"14px",borderRadius:14,fontSize:16,fontWeight:700,letterSpacing:-0.2,opacity:busy?0.65:1,display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
          {busy?"...":(mode==="login"?<>Accedi <span style={{fontSize:18,lineHeight:1}}>→</span></>:"Crea account")}
        </button>

        {/* Toggle mode */}
        <div style={{textAlign:"center",marginTop:20,paddingTop:20,borderTop:`1px solid ${C.border}`,fontSize:14,color:C.muted}}>
          {mode==="login"?"Nessun account? ":"Hai già un account? "}
          <button onClick={()=>{setMode(m=>m==="login"?"signup":"login");setErr("");setInfo("");}}
            style={{background:"none",border:"none",color:C.blue,fontSize:14,cursor:"pointer",fontFamily:FONT_BODY,fontWeight:600,padding:0}}>
            {mode==="login"?"Registrati":"Accedi"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── EXERCISE DETAIL VIEW ────────────────────────────────────────────────────
